<template>
  <search-bar :app-list="appList" :change-route="changeRoute" />
</template>

<script>
import { createRequester } from "@/utility/api.js";
// import { NREST } from "config"
const NREST = "/NREST/";
const request = createRequester();
export default {
  name: "search-box-wrapper",

  props: {
    changeRoute: {
      type: Function,
      require: true
    }
  },

  components: {
    SearchBar: () => import("@/components/search-bar/SearchBar.vue"),
  },

  data() {
    return {
      appList: () => {
        return request({
          url: `${NREST}apps/searchlist`,
          body: JSON.stringify({
            user: {
              sessionid: sessionStorage.getItem("_ticket"),
            },
          }),
        })
          .then(
            ((result) => {
              if (
                result == null ||
                result.message !== undefined ||
                result.response === "unsuccess"
              )
                return [];
              return result;
            }).bind(this)
          )
          .catch(() => []);
      },
    };
  },
};
</script>

<style></style>
